import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { MemberRole, SignupRequest } from '@seo/types';
import { apiPost } from '@/lib/api';
import { type AuthTenant, type AuthUser, useAuthStore } from '@/lib/auth';

interface SignupResponse {
  access_token: string;
  expires_in: number;
  token_type: 'Bearer';
  user: AuthUser;
  tenant: AuthTenant;
}

export function useSignup() {
  const signIn = useAuthStore((s) => s.signIn);
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: SignupRequest): Promise<SignupResponse> => {
      // Purge any cached data from a prior session — see use-login.ts.
      qc.clear();
      return apiPost<SignupResponse>('/v1/auth/signup', input, { unauthenticated: true });
    },
    onSuccess: (data) => {
      // Signup creates the owner of a new tenant.
      signIn({
        accessToken: data.access_token,
        tenant: data.tenant,
        user: data.user,
        role: 'owner' satisfies MemberRole,
      });
    },
  });
}
